import React, { useEffect, useState } from 'react'
import Loader from '../../../components/Loader'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import Responsive from '../../../assets/config/Responsive'
import Input from '../../../components/v2/Input'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { CriticalIllnessState, setInsurerInfo } from '../../../store/criticalIllnessSlice'
import { useSelector } from 'react-redux'
import { AuthState } from '../../../store/authSlice'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import Button from '../../../components/v2/buttons/Button'
import BaseModal from '../../../components/v2/modals/BaseModal'
import Message from '../../../components/Message'
import MovingPrice from '../../../components/v2/MovingPrice'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import api from '../../../api'
import { AppState } from '../../../store/appSlice'

const CriticalPolicyRegistration = () => {
  //
  const { t } = useTranslation()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const dispatch = useAppDispatch()
  //
  const navigate = useNavigate()
  //
  const { checkout, filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-your-contact-info')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  //
  const [openNewPassModal, setOpenNewPassModal] = useState<boolean>(false)
  //
  const [showSmsCodeField, setShowSmsCodeField] = useState<boolean>(false)
  //

  // resend sms play stop timer
  const [showTimer, setShowTimer] = useState<boolean>(false)
  // resend sms timer count
  const [counter, setCounter] = React.useState(60)
  // resend sms count down timer
  useEffect(() => {
    //  start sms timer
    if (showTimer === true) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000)
    }
    // reset sms timer
    if (showTimer === true && counter === 0) {
      setShowTimer(false)
      setCounter(60)
    }
    //
  }, [counter, showTimer])
  //

  // yup validations schema GE
  const ContactValidationSchema = Yup.object({
    email: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .email(`${t('enterValidMail')}`)
      .required(`${t('required')}`),
    phone: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .min(9, `${t('enterValidPhone')}`)
      .max(9, `${t('enterValidPhone')}`)
      .required(`${t('required')}`),
    password: Yup.string()
      .min(8, `${t('minPassLenght')}`)
      .matches(/[0-9]/, `${t('passContainNumber')}`)
      .matches(/[a-z]/, `${t('passContainLowerCase')}`)
      .matches(/[a-zA-Z]/, `${t('passContainEnglishLetters')}`)
      .matches(/[A-Z]/, `${t('passContainUpperCase')}`),
    confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], `${t('enterSamePass')}`),
    smsCode: Yup.string()
      .min(4, `${t('enterFourDigitCode')}`)
      .max(4, `${t('enterFourDigitCode')}`)
      .required(`${t('enterFourDigitCode')}`),
  })
  //
  const MainValidationSchema = ContactValidationSchema
  //
  // initial values
  const initialValues = {
    email: checkout.insurer.email || 'ras',
    phone: checkout.insurer.phone || '',
    password: checkout.insurer.password || '',
    confirmPassword: checkout.insurer.confirmPassword || '',
    smsCode: checkout.insurer.smsCode || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MainValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })
  //
  // new user
  useEffect(() => {
    //
    if (
      // authSmsVerificationError &&
      (auth.user === null || auth.user) &&
      checkout.insurer.smsCode &&
      checkout.insurer.phone &&
      checkout.insurer.smsCode.length === 4 &&
      checkout.insurer.phone.length === 9 &&
      checkout.insurer.email &&
      checkout.insurer.password
    ) {
      const new_user = { email: checkout.insurer.email, password: checkout.insurer.password }
      //
      localStorage.setItem('new_user', JSON.stringify(new_user))
    }
    //
    return () => {}
  }, [
    checkout.insurer.password,
    checkout.insurer.email,
    checkout.insurer.phone,
    checkout.insurer.userHaveAccount,
    // authSmsVerificationError,
    auth.user,
    checkout.insurer.phone?.length,
    checkout.insurer.smsCode,
  ])
  //
  const mainLoading = isPageInfoLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <BaseModal isOpen={openNewPassModal} onClose={() => setOpenNewPassModal(!openNewPassModal)}>
        <NewAccountModalBlock>
          <h5>გაიარე მარტივი რეგისტრაცია</h5>
          <p>შექმენი შენი ანგარიში</p>
          <Input
            id="critical-policy-registration-password"
            name="abroad-policy-registration-password"
            label={t('enterNewPassword')}
            type="password"
            icon={true}
            placeholder=""
            value={checkout.insurer.password || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'password',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('password', value),
            ]}
            width={'fullWidth'}
            error={formik.errors.password && checkout.insurer.password ? true : false}
            errorText={formik.errors.password}
            onBlur={formik.handleBlur}
            style={{
              marginTop: '24px',
            }}
          />

          <Input
            id="critical-policy-confirm-registration-password"
            name="abroad-policy-confirm-registration-password"
            label={t('repeatNewPassword')}
            type="password"
            icon={true}
            placeholder=""
            value={checkout.insurer.confirmPassword || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'confirmPassword',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('confirmPassword', value),
            ]}
            width={'fullWidth'}
            error={formik.errors.confirmPassword && checkout.insurer.confirmPassword ? true : false}
            errorText={formik.errors.confirmPassword}
            onBlur={formik.handleBlur}
            style={{
              marginTop: '24px',
            }}
          />

          <Message
            style={{
              marginTop: '10px',
              marginBottom: '0px',
            }}
            variant="gray"
            text={`${t('passwordText')}`}
          />

          <Button
            fullWidth={true}
            style={{
              marginTop: '48px',
            }}
            disabled={
              checkout.insurer.password &&
              checkout.insurer.confirmPassword &&
              checkout.insurer.password === checkout.insurer.confirmPassword &&
              checkout.insurer.consentTerm
                ? false
                : true
            }
            buttonType="primary"
            text={t('registrationAndContinue')}
            onClick={() => {
              if (
                checkout.insurer.password &&
                checkout.insurer.confirmPassword &&
                checkout.insurer.password === checkout.insurer.confirmPassword &&
                checkout.insurer.consentTerm
              ) {
                //
                // _policyRegistration()
              }
            }}
          />
        </NewAccountModalBlock>
      </BaseModal>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <MovingPrice
          price={
            filter.paymentSchedule?.type === 'MONTHLY'
              ? filter.offer?.calculatedPrices.monthly
              : filter.offer?.calculatedPrices.annual
          }
        />

        <WhiteBox>
          <Input
            id="critical-policy-registration-email"
            name="critical-policy-registration-email"
            label={`${t('email')}`}
            type="email"
            placeholder=""
            value={checkout.insurer.email || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'email',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('email', value),
            ]}
            width={'fullWidth'}
            error={formik.errors.email && checkout.insurer.email ? true : false}
            errorText={formik.errors.email}
            onBlur={formik.handleBlur}
            disabled={
              checkout.insurer.email &&
              checkout.insurer.phone &&
              checkout.insurer.smsCode &&
              checkout.insurer.smsCode.length === 4
                ? true
                : false
            }
          />

          <PhoneDiv>
            <Input
              id="critical-policy-registration-phone"
              name="critical-policy-registration-phone"
              label={`${t('phone')}`}
              type="number"
              placeholder=""
              value={checkout.insurer.phone || ''}
              onChange={(value) => [
                dispatch(
                  setInsurerInfo({
                    fieldName: 'phone',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('phone', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.phone && checkout.insurer.phone ? true : false}
              errorText={formik.errors.phone}
              onBlur={formik.handleBlur}
              style={{
                marginTop: '24px',
              }}
              disabled={
                checkout.insurer.email &&
                checkout.insurer.phone &&
                checkout.insurer.smsCode &&
                checkout.insurer.smsCode.length === 4
                  ? true
                  : false
              }
            />

            <ResendSmsBtn
              style={{
                textDecoration: counter && showTimer === true ? 'none' : 'underline',
              }}
              disabled={false}
              onClick={() =>
                checkout.insurer.phone && checkout.insurer.phone.length === 9 ? setShowSmsCodeField(true) : {}
              }
            >
              {(showSmsCodeField && (
                <div>{counter && showTimer === true ? <CounterSpan>{counter}</CounterSpan> : `${t('Resend')}`}</div>
              )) ||
                `${t('sendSms')}`}
            </ResendSmsBtn>
          </PhoneDiv>

          {showSmsCodeField ? (
            <Input
              id="critical-policy-registration-phone-sms"
              name="critical-policy-registration-phone=sms"
              label={`${t('smsCode')}`}
              type="number"
              placeholder=""
              value={checkout.insurer.smsCode || ''}
              onChange={(value) =>
                dispatch(
                  setInsurerInfo({
                    fieldName: 'smsCode',
                    fieldValue: value,
                  }),
                )
              }
              width={'fullWidth'}
              disabled={false}
              style={{
                marginTop: '24px',
              }}
            />
          ) : null}
        </WhiteBox>

        <Buttons>
          <Buttons>
            <NavigationButton
              text={`${t('back')}`}
              buttonType="prev"
              onClick={() => navigate('/critical-check-information')}
            />

            <NavigationButton
              text={t('next')}
              buttonType="next"
              disabled={false}
              //
              onClick={() => navigate('/critical-payment')}
            />
          </Buttons>
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const NewAccountModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h5 {
    font-size: 24px;
    color: ${Colors.primaryBlack};
  }
  p {
    font-size: 14px;
    color: ${Colors.nevadaGrey};
  }
`

const ResendSmsBtn = styled.button`
  background-color: transparent;
  border: 0px;
  outline: none;
  padding: 5px;
  margin: 0px;
  position: absolute;
  top: 38px;
  right: 23px;
  text-decoration: underline;
  font-size: 12px;
  color: ${Colors.primaryBlack};
`

const PhoneDiv = styled.div`
  position: relative;
  /*  */
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
  border-radius: 8px;
  padding: 34px 48px;

  ${Responsive.mobile} {
    padding: 20px;
  }
`
const Content = styled.div`
  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`

const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  /*  */
  .base-modal-close-btn {
    display: none;
  }
`
const CounterSpan = styled.span`
  background-color: ${Colors.primaryRed};
  color: ${Colors.white};
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -7px;
  margin-right: -6px;

  ${Responsive.mobile} {
    margin-top: -9px;
    margin-right: -19px;
  }
`

export default CriticalPolicyRegistration
